/** Visible label copy — Title Case. */
export const FORM_LABELS = {
  title: 'Title',
  description: 'Description',
} as const

/** Technical field identifiers — camelCase. */
export const FORM_FIELD_IDS = {
  title: 'editPageTitle',
  description: 'editPageDescription',
  titleHint: 'editPageTitleHint',
  titleError: 'editPageTitleError',
  descriptionHint: 'editPageDescriptionHint',
  formError: 'editPageFormError',
  modalTitle: 'createEditPageModal',
} as const

export const TITLE_HINT =
  'use letters, numbers, spaces, and hyphens only — avoid special characters like / \\ # ? &'

export const DESCRIPTION_HINT =
  'optional. add a short note to help others understand this edit'

export const TITLE_REQUIRED_MESSAGE = 'the title is required'

export const EMPTY_FOLDER_MESSAGE = 'folder has no items to create an edit page'

export const CREATE_SUCCESS_MESSAGE = 'edit page created'
export const CREATE_FAILURE_TOAST = 'failed to create edit page'
export const GENERIC_ERROR_MESSAGE = 'Something went wrong'
